// const BASE_URL = "http://localhost:8086";
// export default BASE_URL;
const BASE_URL = process.env.REACT_APP_BASE_URL;
export default BASE_URL;
